import React from 'react';
import {Route, Routes} from 'react-router-dom';
import CreatorLists from '@/views/creators/lists';
import Profile from '@/views/creators/profile/Profile';
import SpinningLoader from '@/components/spinning-loader';

function CreatorsRoutes() {
  return (
    <Routes>
      <Route path="" element={<CreatorLists />} />
      <Route
        path="creator-profile/:creatorId"
        element={
          <Profile
            customLoader={
              <SpinningLoader color="black" containerHeight="100%" />
            }
          />
        }
      />
    </Routes>
  );
}

export default CreatorsRoutes;
